import { useEffect, useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import {
  Button,
  Group,
  Loader,
  Select,
  Stack,
  Text,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import BackButton from "../../../../../components/View/BackButton";
import { IconExternalLink } from "@tabler/icons-react";
import { enrichListByExternalApi } from "../../../../../api/ContactAPI";
import { notifications } from "@mantine/notifications";
import { useParams } from "react-router-dom";
import { getAIKeys } from "../../../../../api/ConfigsApi";
import kaspr_logo from "../../../../../assets/logos/kaspr.png";

const enrichType = "kaspr";

const EnrichDatafieldExternal = ({ handleClose, onFinish }) => {
  const { contactListId } = useParams();
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);

  const [apiKeys, setApiKeys] = useState([]);
  const [loadingKeys, setLoadingKeys] = useState(true);
  const [apiKey, setApiKey] = useState(null);
  const [apiKeyError, setApiKeyError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    setApiKeyError(false);
    if (!apiKey) {
      document.getElementById("api_key").focus();
      return setApiKeyError(true);
    }

    setLoading(true);
    enrichListByExternalApi({
      contact_list_id: parseInt(contactListId),
      filter: { mode: "or", values: [] },
      external_api_key_id: parseInt(apiKey),
      enrich_external_api: enrichType,
    })
      .then((res) => {
        notifications.show({
          message: lang.contact_lists.datafield_content.success_enrich,
          color: "tertiary.8",
        });
        handleClose();
        onFinish?.();
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getAIKeys()
      .then((res) => {
        setApiKeys(
          res.data.external_api_keys_list?.filter((x) => x.type === enrichType)
        );
      })
      .finally(() => setLoadingKeys(false));
  }, []);

  return (
    <Stack
      component={"form"}
      onSubmit={handleSubmit}
      gap={"xs"}
      pos={"relative"}
    >
      <Text fw={600}>
        {lang.contact_lists.datafield_content.dialog.text_enrich_kaspr_info}
      </Text>

      <Group wrap="nowrap" align="start" gap={"sm"}>
        <Select
          id="api_key"
          label={lang.contact_lists.datafield_content.dialog.kaspr_api_key}
          required
          placeholder={
            lang.contact_lists.datafield_content.dialog.kaspr_api_key
          }
          flex={1}
          data={apiKeys.map((item) => ({
            label: item.name,
            value: item.id.toString(),
          }))}
          rightSection={loadingKeys ? <Loader size={16} /> : null}
          value={apiKey}
          onChange={setApiKey}
          error={
            apiKeyError
              ? lang.contact_lists.datafield_content.dialog.api_key_needed
              : null
          }
        />

        <Tooltip label={lang.contact_lists.datafield_content.dialog.keys_list}>
          <Button
            variant="light"
            component={"a"}
            href={`/settings/integrations/main`}
            target="_blank"
            px={12}
            mt={22}
          >
            <IconExternalLink size={18} />
          </Button>
        </Tooltip>
      </Group>

      <Group justify="end" mt={"md"}>
        <BackButton onClick={handleClose} />

        <Button
          leftSection={
            <ThemeIcon size={24} variant="subtle">
              <img src={kaspr_logo} style={{ width: 22 }} />
            </ThemeIcon>
          }
          loading={loading}
          color="primary"
          type="submit"
          size="md"
        >
          {lang.contact_lists.datafield_content.dialog.submit_button_enrich}
        </Button>
      </Group>
    </Stack>
  );
};

export default EnrichDatafieldExternal;
